import { useContext, useEffect, useState } from 'react';

import './EditProductPopup.css';
import AdaptivePopup from '../../../../AdaptivePopup/AdaptivePopup';
import PlatformInput from '../../../PlatformInput/PlatformInput';
import publicApi from '../../../../../assets/api/PublicApi';
import { UserContext } from '../../../../../assets/contexts/userContext';
import { StringOrNothingFormater, getMinPrice, getRandomId, parsePrice } from '../../../../../assets/utils/utils';
import PreloaderBox from '../../../../PreloaderBox/PreloaderBox';
import Button from '../../../../Button/Button';
import { ERROR_PRICE_DATA_MIN_VALUE, ERROR_REQUIRED_FIELD } from '../../../../../assets/utils/constants';








function EditProductPopup({ isOpen, handleClose, handleEditSave, productToEdit, setProductToEdit }) {
    const [formValidity, setFormValidity] = useState({
        price: {},
        amount: {},
    })

    useEffect(() => {
        if (!productToEdit) return
        setFormValidity({
            price: {
                validState: productToEdit && Number(productToEdit.price) > 0 ? true : false
            },
            amount: {
                validState: productToEdit && Number(productToEdit.amount) > 0 && (productToEdit.price_data ? Number(productToEdit.amount) <= Number(productToEdit.price_data.in_stock) : true) ? true : false
            },
        })

    }, [productToEdit])


    function handleChange(e) {
        const value = e.target.value
        const name = e.target.name
        switch (name) {
            case "price": {
                let inputValue = value.replace(/\D/g, "");
                setProductToEdit((prevValue) => ({
                    ...prevValue,
                    [name]: !inputValue ? "" : Number(inputValue).toString(),
                }));
                setFormValidity((prevValue) => ({
                    ...prevValue,
                    [name]: inputValue
                        ? Number(inputValue) > 0
                            ? {
                                errorMessage: "",
                                validState: true,
                            }
                            : {
                                errorMessage: ERROR_PRICE_DATA_MIN_VALUE,
                                validState: false,
                            }
                        : {
                            errorMessage: ERROR_REQUIRED_FIELD,
                            validState: false,
                        },
                }));
                break;
            }

            case "amount": {

                let inputValue = value.replace(/\D/g, "");

                setFormValidity((prevValue) => ({
                    ...prevValue,
                    [name]: inputValue && Number(inputValue) > 0 && (productToEdit.price_data ? Number(inputValue) <= Number(productToEdit.price_data.in_stock) : true) ?
                        {
                            errorMessage: "",
                            validState: true,
                        }
                        :
                        {
                            errorMessage: ERROR_REQUIRED_FIELD,
                            validState: false,
                        },
                }));
                setProductToEdit((prevValue) => ({
                    ...prevValue,
                    [name]: !inputValue ? "" : Number(inputValue).toString(),
                }));
                break;
            }
            default: {
                setProductToEdit(prevValue => ({
                    ...prevValue,
                    [name]: value,
                }))
                break;
            }
        }
    }
    function onClosePopup() {
        handleClose()
        setTimeout(() => {
            setProductToEdit(null)
        }, 300);
    }

    function handleSave() {
        handleEditSave(productToEdit)
        onClosePopup()
    }
    return (
        <AdaptivePopup
            isOpen={isOpen}
            handleClose={onClosePopup}
            popupName={'editProduct'}
        >
            {productToEdit ?
                <div className='edit-product-popup'>
                    <p className='edit-product-popup__title'>Редактировать товар</p>
                    <PlatformInput
                        value={productToEdit.price}
                        handleChange={handleChange}
                        label={'Цена'}
                        type={'text'}
                        inputMode='numeric'
                        name={'price'}
                        show_eror_color_only

                    />
                    <PlatformInput
                        value={productToEdit.amount}
                        handleChange={handleChange}
                        label={`Колличество ${productToEdit.price_data ? `max(${Number(productToEdit.price_data.in_stock)})` : ''}`}
                        type={'text'}
                        inputMode='numeric'
                        name={'amount'}
                        show_eror_color_only

                    />
                    <Button
                        text={'Cохранить'}
                        isInvalid={!(formValidity.price.validState && productToEdit.price && productToEdit.amount && formValidity.amount.validState)}
                        isContrastColor
                        className={'add-products-popup__btn '}
                        onClick={() => {
                            handleSave()
                        }}
                    />
                </div>
                :
                null
            }
        </AdaptivePopup>
    );
}

export default EditProductPopup